export const WEBCOM_NAME = "edtech-course-completion";
